import type { Editor } from '@tiptap/react';
import { type ReactNode, createContext, useContext } from 'react';
import type { EditorFormats } from '../data/.types/editorFormats.ts';

export interface TeaContextType {
  editor: Editor | null;
  setEditor: React.Dispatch<React.SetStateAction<Editor | null>>;
  editorFormats?: EditorFormats;
  baseUrl: string;
}

export const TeaContext = createContext<TeaContextType | null>(null);

export function TeaContextProvider({
  children,
  value,
}: {
  children: ReactNode;
  value: TeaContextType;
}) {
  return <TeaContext.Provider value={value}>{children}</TeaContext.Provider>;
}

export function useTeaContext() {
  const context = useContext(TeaContext);

  if (context === null) {
    throw new Error('useTeaContext must be used within a TeaContextProvider');
  }

  return context;
}
